import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { ContragentCustomerObjectDto } from "../../../../../shared/models/contragent/contragent-customer-object-dto";
import { Router } from "@angular/router";
import { DialogService } from "@progress/kendo-angular-dialog";
import { CreateCustomerObjectComponent } from "../../../../../shared/components/customer-object/create-customer-object/create-customer-object.component";
import { CustomerObjectsService } from "../../../../customer-objects/customer-objects.service";
import { RequestPageCustomerObjectContactsComponent } from "../../../../../shared/components/request-page/request-page-customer-object/sub-components/request-page-customer-object-contacts/request-page-customer-object-contacts.component";
import { Request } from "../../../../../shared/models/request/request";
import { RequestStatus, RequestType } from "../../../../../shared/enums";
import { SecurityService } from "../../../../../core/services/security.service";
import { RequestsService } from "../../../../../shared/services/requests.service";
import { CustomerObjectWithContactsDto } from '../../../../../shared/models/customerObject/customer-object-with-contacts.dto';
import { ContragentsService } from '../../../contragents.service';
import { KeyValueObject } from '../../../../../shared/models/core/KeyValueObject';



@Component({
	selector: 'contragent-customer-objects',
	templateUrl: './contragent-customer-objects.component.html',
	styleUrls: [
        './contragent-customer-objects.component.scss',
		'../../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
	],
    encapsulation: ViewEncapsulation.None
})
export class ContragentCustomerObjectsComponent implements OnInit {

    @ViewChild("customerObjectContacts") customerObjectContacts: RequestPageCustomerObjectContactsComponent;

    @Input() contragentId: number;
    @Input() customerObjects: ContragentCustomerObjectDto[] = [];

    selectedCustomerObject: ContragentCustomerObjectDto = null;
    selectedCustomerObjectCoordinates: number[] = [];
    selectedCustomerObjectHasCoordinates: boolean = false;
    createServiceRequestLoading: boolean = false;

    constructor(
        protected router: Router,
        private dialogService: DialogService,
        private customerObjectsService: CustomerObjectsService,
        private securityService: SecurityService,
        private requestsService: RequestsService,
        private contragentsService: ContragentsService
    ) { }

    ngOnInit(): void {
        if (this.customerObjects && this.customerObjects.length > 0) {
            this.selectCustomerObject(this.customerObjects[0]);
        } 
    }

	selectCustomerObject(customerObject: ContragentCustomerObjectDto) {
        this.selectedCustomerObject = customerObject;

        if (this.selectedCustomerObject && 
            this.selectedCustomerObject.latitude && 
            this.selectedCustomerObject.longitude) 
        {
            this.selectedCustomerObjectHasCoordinates = true;
            this.selectedCustomerObjectCoordinates = [
                this.selectedCustomerObject.latitude, 
                this.selectedCustomerObject.longitude];
        }
        else {
            this.selectedCustomerObjectCoordinates = [55.751952, 37.600739];
            this.selectedCustomerObjectHasCoordinates = false;
        }
    }

    editSelectedCustomerObject() {
        this.customerObjectsService.getCustomerObjectWithContacts(this.selectedCustomerObject.customerObjectId).subscribe(resp => {
            const dialogRef = this.dialogService.open({
                content: CreateCustomerObjectComponent,
                width: '60%', 
                height: '620px'
            });

            const dialog = <CreateCustomerObjectComponent>dialogRef.content.instance;

            dialog.selectedCustomerObject = resp;
            dialog.contragentId = this.contragentId;
            dialog.isEditing = true;
            
            dialog.onCancelEvent.subscribe(() => {
                dialogRef.close();
            });
            dialog.onContinueEvent.subscribe(() => {
                this.refreshCustomerObjects(this.selectedCustomerObject.customerObjectId);
                dialogRef.close();
            });
        })
    }

    createCustomerObject() {
        const dialogRef = this.dialogService.open({
            content: CreateCustomerObjectComponent,
            width: '60%',
            height: '720px'
        });

        const dialog = <CreateCustomerObjectComponent>dialogRef.content.instance;

        dialog.selectedCustomerObject = new CustomerObjectWithContactsDto();
        dialog.customerObjects = this.customerObjects.map(x => new KeyValueObject(x.customerObjectId, x.name));
        dialog.contragentId = this.contragentId;
        dialog.isEditing = false;

        dialog.onCancelEvent.subscribe(() => {
            dialogRef.close();
        });
        dialog.onContinueEvent.subscribe((customerObject) => {
            this.refreshCustomerObjects(customerObject.customerObjectId);
            dialogRef.close();
        });
    }

    refreshCustomerObjects(selectedCustomerObjectId: number) {
        this.contragentsService.getContragentWithContact(this.contragentId).subscribe((contragent) => {
            const customerObjects = contragent.customerObjects || [];

            this.customerObjects.splice(0, this.customerObjects.length, ...customerObjects);
            const selectedCustomerObject = this.customerObjects.find(x => x.customerObjectId === selectedCustomerObjectId)
                || this.customerObjects[0]
                || null;

            this.selectCustomerObject(selectedCustomerObject);
            if (this.customerObjectContacts) {
                this.customerObjectContacts.initData();
            }
        });
    }

    routeToCustomerObjectPage(customerObjectId: number) {
        window.open(`/categories/customer-object/${customerObjectId}`, '_blank');
    }

    createServiceRequest() {
        this.createServiceRequestLoading = true;

        let newRequest = new Request;
        newRequest.customerContragentId = this.contragentId;
        newRequest.customerObjectId = this.selectedCustomerObject.customerObjectId;
        newRequest.performerUserId = this.securityService._currentUser.userId;
        newRequest.requestTypeId = <number>RequestType.service;
        newRequest.statusId = <number>RequestStatus.InProgress;

        this.requestsService.create(newRequest).subscribe((resp) => {
            window.open(`/requests/${resp.data}`, '_blank');
            this.createServiceRequestLoading = false;
        });
    }

    get cardHeight(): number {
        return this.hasCustomerObjects ? 475 : 120;
    }

    get hasCustomerObjects(): boolean {
        return this.customerObjects && this.customerObjects.length > 0;
    }

}
